<template>
  <div class="footer">
    <b-modal
      id="modal-cgu"
      :title="
        $t(
          'Conditions générales d\'utilisation de la plateforme Ooftop - Dernière mise à jour : 2 janvier 2023'
        )
      "
      hide-footer
    >
      <CGU></CGU>
    </b-modal>
    <b-modal
      id="modal-cookies"
      :title="
        $t(
          'Politique de cookies de la solution de valorisation de biens immobiliers - Mis à jour le 2/01/2023'
        )
      "
      hide-footer
    >
      <COOKIES></COOKIES>
    </b-modal>
  </div>
</template>

<script>
import axios from "axios";
import CGU from "@/components/CGU";
import COOKIES from "@/components/COOKIES";
export default {
  name: "RwvFooter",
  components: { CGU, COOKIES },
  mounted() {
    var p = this;
    window.setInterval(function() {
      if (p.auth_header()) {
        axios
          .get(p.$apiUrl + "user/checkLogin", {
            params: { auth: p.auth_header() },
          })
          .then((response) => {
            if (
              response.data == "notlogged" ||
              parseFloat(response.data) > 30
            ) {
              p.logout();
              p.$router.push({ path: "/" });
            } else {
            }
          })
          .catch((error) => {});
      }
    }, 150000);
  },
  methods: {},
};
</script>
